import React from "react";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import BasketResetOrder from "./basket-reset-order";

const BasketDeliveryAddress = ({ basketCount, deliveryAddress }) => (
  <div className="delivery-address">
    <Row>
      <Col xs={12}>
        <h2>delivery address</h2>
        {basketCount > 0 && deliveryAddress && (
          <span className="text">
                {deliveryAddress.name} {deliveryAddress.customer_number}
              </span>
        )}
      </Col>
      <Col xs={12}>
        <BasketResetOrder value="Change address and restart order" />
      </Col>
    </Row>
  </div>
);

const mapStateToProps = state => {
  return {
    basketCount: Object.values(state.orders.new.basket.line_items).reduce(
      (sum, { product_qty }) => sum + product_qty,
      0
    ),
    deliveryAddress: state.orders.new.deliveryAddress,
  };
};
export default connect(mapStateToProps)(BasketDeliveryAddress);



// WEBPACK FOOTER //
// ./src/components/new-order/basket/basket-delivery-address.jsx